const STATUS = '1';
const MSG = 'ERROR';
const ERROR_TYPE = 'internal';
const ERROR_CODE = 'accept_terms';
const ERROR_DESCRIPTION =
  'Debes aceptar los Términos y Condiciones del servicio.';

const termsNotAccepted = async error => {
  const resposeData = error.response.data;
  const { response, ...customResponseData } = error;

  const newError = {
    response: resposeData.data,
    status: STATUS,
    msg: MSG,
    errors: {
      type: ERROR_TYPE,
      error: [ERROR_DESCRIPTION],
      code: ERROR_CODE,
    },
  };

  const newResponse = { ...customResponseData, ...newError };
  // eslint-disable-next-line no-param-reassign
  error.response.data = newResponse;
};

export default termsNotAccepted;
